function NavLink({ href, active, children, onNavigate }) {
  const handleClick = (event) => {
    if (href.startsWith("/")) {
      event.preventDefault();
      onNavigate(href);
    }
  };

  return (
    <a
      href={href}
      onClick={handleClick}
      className={`rounded-lg px-2.5 py-2 text-sm font-medium transition-all duration-200 ease-in-out active:translate-y-px focus-visible:shadow-focus-ring ${
        active ? "text-primary" : "text-secondary hover:text-primary"
      }`}
    >
      {children}
    </a>
  );
}

export default NavLink;
